import { TableTypeModel } from "./table-type.model";

export class TableGroupModel{
  public id: string;
  public index: number;
  public name: string;
  public capacityTables: Array<TableTypeModel> = new Array<TableTypeModel>();
}
